module.exports = __webpack_public_path__ + "img/26_49.6cbaa418.png";